"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _CompletedContext = require("../CompletedContext");

var _DesignComponents = require("../DesignComponents/DesignComponents");

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));

var _DraggableOption = _interopRequireDefault(require("./DraggableOption"));

var _DroppableCategory = _interopRequireDefault(require("./DroppableCategory"));

var _DndProvider = _interopRequireDefault(require("../DndProvider"));

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _CustomDragLayer = require("./CustomDragLayer");

var _reactDndTouchBackend = require("react-dnd-touch-backend");

var _Row = _interopRequireDefault(require("react-bootstrap/Row"));

var _Col = _interopRequireDefault(require("react-bootstrap/Col"));

var _util = require("../util");

require("./TaskSorting.scss");

var TaskSorting = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskSorting, _Component);

  var _super = (0, _createSuper2.default)(TaskSorting);

  function TaskSorting(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskSorting);
    _this = _super.call(this, props);

    _this.setDropdownState = function (optionIndex, isOpen) {
      var stateCopy = _this.state.dropdownState.slice();

      stateCopy[optionIndex] = isOpen;

      _this.setState({
        dropdownState: stateCopy
      });
    };

    _this.setFocusState = function (optionIndex) {
      _this.setState({
        focusState: optionIndex
      });
    };

    _this.optionContainerOnChange = function (newCategory, optionk, prevCategory) {
      var newOptionsArray = _this.state.options.map(function (value, optIndex) {
        if (optionk === optIndex) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
            currentCategory: newCategory
          });
        }

        return value;
      }); // rebuild optionMap


      var newOptionsMap = {};
      Object.keys(_this.state.optionMap).forEach(function (categoryKey) {
        var category = _this.state.optionMap[categoryKey].slice(); // create copy to modify


        if (categoryKey === prevCategory.toString()) {
          category.splice(category.indexOf(optionk), 1); // remove that option from its prev category
        } else if (categoryKey === newCategory.toString()) {
          category.push(optionk); // move option to new category
        }

        newOptionsMap[categoryKey] = category;
      });

      _this.setState({
        options: newOptionsArray,
        optionMap: newOptionsMap
      }, function () {
        _this.setState({
          canSubmit: _this.isAnswerBankEmpty()
        });
      });
    };

    _this.handleSubmit = function () {
      var completed = true;

      for (var i = 0; i < _this.state.options.length; ++i) {
        if (_this.state.options[i].currentCategory !== _this.state.options[i].correctCategory) {
          completed = false;
        }
      }

      _this.setState({
        completed: completed,
        showModal: true,
        feedback: completed ? _this.props.feedbackCorrect : _this.props.feedbackIncorrect
      });
    };

    _this.state = props.state || {};

    if (!_this.state.initialized) {
      var _props$maxOptionsPerR;

      _this.state.initialized = true;
      _this.state.completed = false;
      _this.state.feedback = undefined;
      _this.state.showModal = false;
      _this.state.canSubmit = false;
      _this.state.maxOptionsPerRow = (_props$maxOptionsPerR = props.maxOptionsPerRow) !== null && _props$maxOptionsPerR !== void 0 ? _props$maxOptionsPerR : 3;
      _this.state.options = _this.props.children.map(function (option) {
        return {
          currentCategory: -1,
          correctCategory: option.props.category
        };
      });
      _this.state.indexMap = (0, _util.shuffle)(Array.from(Array(_this.state.options.length).keys()));
      _this.state.optionMap = _this.createOptionMap();
      _this.state.dropdownState = Array.from(Array(_this.props.children.length).keys).fill(false);
      _this.state.focusState = -1;
    }

    _this.optionContainerOnChange.bind((0, _assertThisInitialized2.default)(_this));

    _this.setDropdownState.bind((0, _assertThisInitialized2.default)(_this));

    _this.setFocusState.bind((0, _assertThisInitialized2.default)(_this));

    return _this;
  }

  (0, _createClass2.default)(TaskSorting, [{
    key: "isAnswerBankEmpty",
    value: function isAnswerBankEmpty() {
      return this.state.optionMap["-1"].length === 0;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "isTouchDevice",
    value: function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "createOptionMap",
    value: function createOptionMap() {
      // -1 is container for unsorted options
      var optionMap = {
        "-1": []
      };

      for (var i = 0; i < this.props.categories.length; ++i) {
        optionMap["".concat(i)] = [];
      }

      for (var _i2 = 0; _i2 < this.state.indexMap.length; ++_i2) {
        if (!this.props.randomize) {
          optionMap["-1"].push(_i2);
        } else {
          optionMap["-1"].push(this.state.indexMap[_i2]);
        }
      }

      return optionMap;
    }
  }, {
    key: "generateOptionElements",
    value: function generateOptionElements() {
      var optionElements = {
        "-1": []
      };

      for (var i = 0; i < this.props.categories.length; ++i) {
        optionElements["".concat(i)] = [];
      } // convert the optionMap data to elements


      for (var _i3 = 0, _Object$keys2 = Object.keys(this.state.optionMap); _i3 < _Object$keys2.length; _i3++) {
        var category = _Object$keys2[_i3];

        for (var _i4 = 0; _i4 < this.state.optionMap[category].length; ++_i4) {
          var optionIndex = this.state.optionMap[category][_i4];
          optionElements[category].push( /*#__PURE__*/_react.default.createElement(_DraggableOption.default, {
            key: optionIndex,
            id: "draggable-option-".concat(optionIndex),
            optionName: this.props.children[optionIndex],
            optionK: optionIndex,
            categories: this.props.categories,
            stateOptions: this.state.options,
            optionContainerOnChange: this.optionContainerOnChange,
            completed: this.state.completed,
            dropdownState: this.state.dropdownState[optionIndex],
            setDropdownState: this.setDropdownState,
            focusState: this.state.focusState,
            setFocusState: this.setFocusState
          }));
        }
      } // organize into rows (rows are vertical for spacing)


      var rowCount = this.props.children.length < this.state.maxOptionsPerRow ? this.props.children.length : this.state.maxOptionsPerRow;
      var optionContainerGrid = [];

      for (var _i5 = 0; _i5 < rowCount; ++_i5) {
        optionContainerGrid.push([]);
      }

      var rowCounter = 0;

      for (var _i6 = 0; _i6 < optionElements["-1"].length; ++_i6) {
        if (rowCounter === rowCount) {
          rowCounter = 0;
        }

        optionContainerGrid[rowCounter].push(optionElements["-1"][_i6]);
        rowCounter += 1;
      }

      for (var _i7 = 0; _i7 < rowCount; ++_i7) {
        optionContainerGrid[_i7] = /*#__PURE__*/_react.default.createElement(_Col.default, {
          className: "sorting-option-col"
        }, optionContainerGrid[_i7]);
      }

      optionElements["-1"] = /*#__PURE__*/_react.default.createElement(_Row.default, {
        style: {
          margin: "0px 0px"
        },
        xs: 1,
        sm: rowCount,
        className: "sorting-option-row"
      }, optionContainerGrid);
      return optionElements;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var noOptions = this.isAnswerBankEmpty();
      var optionElements = this.generateOptionElements();
      return /*#__PURE__*/_react.default.createElement(_DndProvider.default, {
        backend: this.isTouchDevice() ? _reactDndTouchBackend.TouchBackend : _reactDndHtml5Backend.HTML5Backend,
        context: window
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Row.default, {
        className: "sorting-prompt"
      }, this.props.prompt), /*#__PURE__*/_react.default.createElement("div", {
        className: "answer-options-text"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "answer-options-subtext"
      }, "Answer Choices:"), /*#__PURE__*/_react.default.createElement("div", {
        className: "answer-option-container" + (noOptions ? " sorting-center-text" : "")
      }, noOptions && /*#__PURE__*/_react.default.createElement("div", {
        className: "empty-option-text"
      }, /*#__PURE__*/_react.default.createElement("i", null, "No more answer choices to sort")), optionElements["-1"], /*#__PURE__*/_react.default.createElement(_CustomDragLayer.CustomDragLayer, {
        stateOptions: this.state.options
      }))), /*#__PURE__*/_react.default.createElement(_Row.default, {
        xs: 1,
        sm: this.props.categories.length,
        style: {
          marginTop: "10px",
          marginLeft: "24px",
          marginRight: "24px"
        }
      }, this.props.categories.map(function (v, categoryIndex) {
        return /*#__PURE__*/_react.default.createElement(_Col.default, {
          style: {
            padding: "0px 5px"
          }
        }, /*#__PURE__*/_react.default.createElement(_DroppableCategory.default, {
          value: v,
          categoryIndex: categoryIndex,
          stateOptions: _this3.state.options,
          childOptions: optionElements["".concat(categoryIndex)]
        }));
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          marginTop: "4px",
          marginBottom: "50px",
          justifyContent: "right",
          display: "flex"
        }
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        className: "bdg-submit-button",
        type: "submit",
        disabled: this.state.completed || !this.state.canSubmit,
        onClick: this.handleSubmit,
        style: {
          marginRight: "24px",
          fontWeight: "bold",
          backgroundColor: this.state.completed || !this.state.canSubmit ? "#e2e8ee" : "#1a8082"
        }
      }, "Submit")), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showModal,
        correct: this.state.completed,
        onHide: function onHide() {
          _this3.setState({
            showModal: false
          });
        }
      }, this.state.feedback)));
    }
  }], [{
    key: "Option",
    value: function Option(props) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "sorting-option-content"
      }, props.children);
    }
  }]);
  return TaskSorting;
}(_react.Component);

exports.default = TaskSorting;
TaskSorting.contextType = _CompletedContext.CompletedContext;